import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import {End} from "@/module/common/End";
import NotifyTemplate from "@/module/notify/NotifyTemplate";
import ParamProxy from "@/module/thing/ParamProxy";

export class DdebugOnline {
    deviceId!: number
    online!: boolean
}

export class DdebugControlForm {
    deviceId!: number
    identifier!: string
    args!: {}
    end!: End
    isRealDevice!: boolean
}

export class DdebugNotifyByWxOaForm {
    deviceId!: number
    paramProxies!: Array<ParamProxy>
    args!: { [key: string]: string }
    template!: NotifyTemplate
}

@Singleton
export default abstract class DeviceDebugApi {

    abstract online(deviceId: number, online: boolean): Promise<void>

    abstract control(form: DdebugControlForm): Promise<void>

    abstract notifyByWxOa(form: DdebugNotifyByWxOaForm): Promise<void>
}

class DeviceDebugApiImpl extends BaseApi implements DeviceDebugApi {

    protected urlPrefix = 'device/debug'

    online(deviceId: number, online: boolean): Promise<void> {
        return this.axios.post('online', {deviceId: deviceId, online: online})
    }

    control(form: DdebugControlForm): Promise<void> {
        return this.axios.post('control', form)
    }

    notifyByWxOa(form: DdebugNotifyByWxOaForm): Promise<void> {
        return this.axios.post('notifyByWxOa', form)
    }
}

Container.bind(DeviceDebugApi).to(DeviceDebugApiImpl)
